(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-packages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function initGrid(grid) {
      if (grid.dataset.ppInit) return;
      grid.dataset.ppInit = '1';

      var inputs = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-input]'));
      var subtotalEl = grid.querySelector('[data-pp-subtotal]');
      var savingsEl = grid.querySelector('[data-pp-savings]');
      var totalEl = grid.querySelector('[data-pp-total]');
      var submitBtn = grid.querySelector('[data-pp-submit]');
      var form = grid.querySelector('[data-pp-form]');
      var errorEl = grid.querySelector('[data-pp-error]');

      var accountEl = grid.querySelector('[data-pp-account]');
      var accountErrorEl = grid.querySelector('[data-pp-account-error]');
      var firstNameEl = grid.querySelector('[data-pp-first-name]');
      var lastNameEl = grid.querySelector('[data-pp-last-name]');
      var emailEl = grid.querySelector('[data-pp-email]');
      var phoneEl = grid.querySelector('[data-pp-phone]');
      var locationEl = grid.querySelector('[data-pp-location]');

      function showAccountError(message, field) {
        if (accountErrorEl) {
          accountErrorEl.hidden = false;
          accountErrorEl.textContent = message;
        }

        if (field) {
          field.focus();
          field.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }

      function accountProperties() {
        var firstName = firstNameEl ? firstNameEl.value.trim() : '';
        var lastName = lastNameEl ? lastNameEl.value.trim() : '';
        var email = emailEl ? emailEl.value.trim() : '';
        var phone = phoneEl ? phoneEl.value.trim() : '';
        var location = locationEl ? locationEl.value : '';

        if (!firstName) {
          showAccountError('Please enter your first name.', firstNameEl);
          return null;
        }

        if (!lastName) {
          showAccountError('Please enter your last name.', lastNameEl);
          return null;
        }

        if (!email) {
          showAccountError('Please enter your email.', emailEl);
          return null;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showAccountError('Please enter a valid email.', emailEl);
          return null;
        }

        if (!phone) {
          showAccountError('Please enter your phone number.', phoneEl);
          return null;
        }

        if (locationEl && !location) {
          showAccountError('Please choose a location.', locationEl);
          return null;
        }

        var properties = {};

        properties[
          (accountEl && accountEl.dataset.firstNameProperty) ||
          'Account holder first name'
        ] = firstName;

        properties[
          (accountEl && accountEl.dataset.lastNameProperty) ||
          'Account holder last name'
        ] = lastName;

        properties[
          (accountEl && accountEl.dataset.emailProperty) ||
          'Account holder email'
        ] = email;

        properties[
          (accountEl && accountEl.dataset.phoneProperty) ||
          'Account holder phone'
        ] = phone;

        if (locationEl) {
          properties[(accountEl && accountEl.dataset.locationProperty) || 'Clinic location'] = location;
        }

        return properties;
      }

      function recalc() {
        var subtotal = 0;
        var total = 0;
        var count = 0;

        inputs.forEach(function (input) {
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;

          var price = parseInt(input.dataset.price, 10) || 0;
          var original = parseInt(input.dataset.original, 10) || price;
          var line = price * qty;

          subtotal += original * qty;
          total += line;
          count += qty;

          var card = input.closest('.pp-card');
          var lineEl = card && card.querySelector('[data-pp-line]');
          if (lineEl) lineEl.textContent = money(line);

          var subEl = card && card.querySelector('[data-pp-line-sub]');
          if (subEl) {
            var blockValue = parseInt(input.dataset.blockValue, 10) || 0;
            subEl.textContent = qty > 0 ? money(blockValue * qty) + ' credit' : '';
          }
        });

        var savings = subtotal - total;
        if (subtotalEl) subtotalEl.textContent = money(subtotal);
        if (savingsEl) savingsEl.textContent = (savings > 0 ? '- ' : '') + money(savings);
        if (totalEl) totalEl.textContent = money(total);
        if (submitBtn) submitBtn.disabled = count <= 0;
      }

      inputs.forEach(function (input) {
        input.addEventListener('input', recalc);
        input.addEventListener('change', function () {
          var q = parseInt(input.value, 10);
          if (isNaN(q) || q < 0) input.value = 0;
          recalc();
        });
      });

      function addItems(items, btn) {
        if (!items.length) return;
        var properties = accountProperties();
        if (!properties) return;
        items = items.map(function (item) {
          return Object.assign({}, item, { properties: properties });
        });
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (btn) {
          btn.disabled = true;
          btn.classList.add('is-loading');
        }

        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (d) {
                throw new Error(d.description || d.message || 'Sorry, this could not be added to your cart.');
              });
            }
            return r.json();
          })
          .then(function () {
            window.location = root() + 'cart';
          })
          .catch(function (err) {
            if (btn) {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message;
            }
          });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var items = [];
          inputs.forEach(function (input) {
            var qty = parseInt(input.value, 10) || 0;
            var id = input.dataset.variant;
            if (qty > 0 && id) items.push({ id: id, quantity: qty });
          });
          addItems(items, submitBtn);
        });
      }

      grid.querySelectorAll('[data-pp-card-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.pp-card');
          var input = card && card.querySelector('[data-pp-input]');
          if (!input) return;
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 1) {
            qty = 1;
            input.value = 1;
            recalc();
          }
          var id = input.dataset.variant;
          if (!id) return;
          addItems([{ id: id, quantity: qty }], btn);
        });
      });

      [
        firstNameEl,
        lastNameEl,
        emailEl,
        phoneEl,
        locationEl
      ].forEach(function (field) {
        if (!field) return;

        field.addEventListener('input', function () {
          if (accountErrorEl) {
            accountErrorEl.hidden = true;
            accountErrorEl.textContent = '';
          }
        });
      });

      recalc();
    }

    function scan() {
      document.querySelectorAll('[data-pricing-grid]').forEach(initGrid);
    }

    if (document.readyState !== 'loading') {
      scan();
    } else {
      document.addEventListener('DOMContentLoaded', scan);
    }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
